import { render, staticRenderFns } from "./PaymentNotificationBubble.vue?vue&type=template&id=0469f22e&scoped=true"
import script from "./PaymentNotificationBubble.vue?vue&type=script&lang=js"
export * from "./PaymentNotificationBubble.vue?vue&type=script&lang=js"
import style0 from "./PaymentNotificationBubble.vue?vue&type=style&index=0&id=0469f22e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0469f22e",
  null
  
)

export default component.exports